/* eslint-disable @typescript-eslint/no-implied-eval */

import { IConversionFormulaSubmitObj } from '../types/ConversionCalculator.type';

export enum EFormulaType {
  NOMINATION_CALCULATOR = 4,
}

export const getFormulaForDisplay = (data: IConversionFormulaSubmitObj) => {
  let newFormula = data.formula;
  newFormula = newFormula.replaceAll('V1', `{${data.labelV1}}`);
  newFormula = newFormula.replaceAll('V2', `{${data.labelV2}}`);
  newFormula = newFormula.replaceAll('V3', `{${data.labelV3}}`);
  newFormula = newFormula.replaceAll('V4', `{${data.labelV4}}`);
  newFormula = newFormula.replaceAll('V5', `{${data.labelV5}}`);
  newFormula = newFormula.replaceAll('V6', `{${data.labelV6}}`);
  return newFormula;
};
